import { formatDistance } from 'date-fns';

export const timeAgoSince = (dateTime) => {
   var now = new Date();
   var beforeDate = new Date(dateTime);
   var beforeDateWithTimezone = new Date(beforeDate.getFullYear(), beforeDate.getMonth(), beforeDate.getDate(), beforeDate.getHours(), beforeDate.getMinutes() - beforeDate.getTimezoneOffset(), beforeDate.getSeconds());
   return formatDistance(beforeDateWithTimezone, now, { addSuffix: true });
};
